/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrdershippingPendrivesEditor extends Common.GridEditorBase<OrdershippingPendrivesRow> {

        protected getColumnsKey() { return 'Orders.OrdershippingPendrives'; }
        protected getDialogType() { return OrdershippingPendrivesEditDialog; }

        protected getLocalTextPrefix() { return OrdershippingPendrivesRow.localTextPrefix; }
        public vOrderId: number;

        constructor(container: JQuery) {
            super(container);
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').show();
        }
     
        protected getAddButtonCaption() {
            return "Add";
        }
        //validateEntity(row: Enquiry.EnquiryProductsRow, id: number) {
       
            
        //    var sameProduct = Q.tryFirst(this.view.getItems(), x => x.InvoiceId == row.InvoiceId);

        //    if (sameProduct && this.id(sameProduct) !== id) {
        //        Q.alert('This Invoice is already added!');
        //        return false;
        //    }
        //    //row.PoId = Purchase.Po_HeadRow.getLookup().itemById[row.StudentTempDetail].PoId;
        //    return true;
        //}

        protected initEntityDialog(itemType: string, dialog: Serenity.Widget<any>) {
            super.initEntityDialog(itemType, dialog);
            // passing discount from grid editor to detail dialog
            (dialog as OrdershippingPendrivesEditDialog).vOrderId = this.vOrderId;
        }
        //get selectedItems() {
        //    return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        //}



    }
}